// import { combineReducers } from '../../../../../../../home/axel/.cache/typescript/2.9/node_modules/redux';
import speedtestReducer from './speedtests';

export default speedtestReducer;
